import { DatePicker, H3, L80 } from "@adfenix/alexandria";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { ReadLayerContext } from "./ReadLayerQueryContext";

interface DateRangeProps {
  column: string;
  label?: string;
  placeholder?: string;
  showLabel?: boolean;
}

const StyledDatePicker = styled(DatePicker)`
  border-color: ${({ theme }) => L80(theme.colors.grey)} !important;
  ::placeholder {
    color: hsl(0, 0%, 50%);
  }
  color: hsl(0, 0%, 20%);
`;

const StyledParent = styled.div`\
  width: 100%;
  > div {
    width: 100%;
    color: hsl(0, 0%, 60%);
  }

  & button::after {
    background-color : transparent;
    color : hsl(0, 0%, 80%);
    width : 20px;
    padding-right : 12px;
    font-size : 28px;
    font-weight: 600;
  }

  & button::after:hover {
    color: hsl(0, 0%, 60%);
  }
`;

export const DateRange = ({
  column,
  label,
  placeholder,
  showLabel
}: DateRangeProps) => {
  const [startDate, setStartDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();

  const ctx = useContext(ReadLayerContext);

  const { query, addFilter } = ctx!;

  useEffect(() => {
    if (query.filters.find(x => x.column === column)?.fromDateTimeUtc)
      setStartDate(
        new Date(
          query.filters.find(x => x.column === column)?.fromDateTimeUtc ?? ""
        )
      );
    else setStartDate(null);

    if (query.filters.find(x => x.column === column)?.toDateTimeUtc) {
      const endDate = new Date(
        query.filters.find(x => x.column === column)?.toDateTimeUtc ?? ""
      );

      endDate.setDate(endDate.getDate() - 1);

      setEndDate(endDate);
    } else setEndDate(null);
  }, [column, query.filters]);

  if (!ctx) return null;

  // eslint-disable-next-line
  const onChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if ((start && end) || (!start && !end)) {
      if (end) end.setDate(end.getDate() + 1);

      addFilter({
        column,
        fromDateTimeUtc: start
          ? new Date(
              Date.UTC(
                start.getFullYear(),
                start.getMonth(),
                start.getDate(),
                0,
                0,
                0
              )
            ).toISOString()
          : undefined,
        toDateTimeUtc: end
          ? new Date(
              Date.UTC(
                end.getFullYear(),
                end.getMonth(),
                end.getDate(),
                0,
                0,
                0
              )
            ).toISOString()
          : undefined
      });
    }
  };

  return (
    <>
      {showLabel && <H3>{label ?? column}</H3>}
      <StyledParent>
        <StyledDatePicker
          dateFormat="yyyy-MM-dd"
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          placeholderText={placeholder}
          isClearable={true}
        />
      </StyledParent>
    </>
  );
};
